import React from 'react';
import jet from "@randajan/jet-core";

import "./Review.scss";
import { Link } from '@randajan/jet-react/dom/link';
import { Bar } from '@randajan/jet-react/dom/form';
import { usePop } from '@randajan/jet-react/dom/modal';
import { Rating } from '../../../../elements/Rating/Rating';
import { Block } from '@randajan/jet-react/dom/block';

const shrink = (str, maxLength, suffix="")=>{
    str = String.jet.to(str);
    maxLength = Math.max(0, Number.jet.to(maxLength));
    if (!maxLength || str.length < maxLength) { return str; }
    const precut = str.substring(0, maxLength - suffix.length);
    const midword = (precut.match(/[^\S][\S]*$/) || [""])[0];
    const mwlength = midword.length;
    const cut = (mwlength > (maxLength / 4)) ? precut : precut.slice(0, -mwlength);
    return cut + suffix;
}

const ReviewFooter = props=>{
    const { name, source } = props;
    return (
        <div className="footer">
            <div className="name">{name}</div>
            <div className="source">{source ? <Link to={source}>Zdroj</Link> : null}</div>
        </div>
    )
}

const ReviewRaw = props=>{
    const { id, rating, children } = props;

    return (
        <Block className="Review" id={"review-"+id}>
            <Bar value={rating} step={10} marker={<Rating/>}/>
            <div className="rating">{Math.round(rating/10)/2}/5</div>
            {children}
        </Block>
    );
}

export const ReviewFull = props=>{
    const { reply, text, } = props;

    return (
        <ReviewRaw {...props}>
            <p className="text">{text}</p>
            <ReviewFooter {...props}/>
            {!reply ? null : <Block className="reply" caption="Odpověděli jsme:">
                <p className="text">{reply}</p>
            </Block>}
        </ReviewRaw>
    );
}

export const ReviewShort = props=>{

    const { reply, text, maxLength } = props;
    const pop = usePop();

    const stext = shrink(text, maxLength, "...");

    const showMore = (reply || text?.length > stext.length);

    return (
        <ReviewRaw {...props}>
            <div className="text">{stext}</div>
            {showMore ? <a className="popup" onClick={_=>pop.up(<ReviewFull {...props}/>)}>číst dál</a> : null}
            <ReviewFooter {...props}/>
        </ReviewRaw>
    );
}